import {XdhMap, XdhMapImage, XdhMapZoom, XdhMapScale, XdhMapOverview, XdhMapPlacement, XdhMapPointer, XdhMapMeasure, AreaSelectClass as AreaSelect} from 'xdh-map'
import 'xdh-map/lib/xdhmap.css'
// import {Projection} from 'ol/proj.js'
// import {Fill, Stroke, Circle, Style} from 'ol/style'
import ShowStreamNodeModal from '../../common/showStreamNodeModal'
import VideoPlayerModal from '../../common/VideoPlayerModal'
import {debounce, throttle} from '@/utils/public'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js'

export default {
  name: 'xdhDeviceMap',
  data () {
    return {
      rawMap: null,
      rawMapView: null,
      mapLoaded: false,
      mapUrl: this.$globalConfig.mapUrl,
      mapZoom: this.$globalConfig.mapZoom,
      mapCenter: this.$globalConfig.mapCenter,
      geographicExtent: [],
      gisMarkers: [],
      currentGismarker: null,
      selectedGismarkers: [],
      gisMarkerParams: {
        regionId: 0,
        resourceId: 0,
        resourceKind: 21,
        resourceSubType: 255,
        minZoom: this.mapZoom,
        geographyCoordinateFiltered: 0, // 地理坐标过滤
        minLongitude: null,
        maxLongitude: null,
        minLatitude: null,
        maxLatitude: null,
        filterText: '',
        encoderStateRequired: 1, // 要求返回监控设备状态
        streamServerInfoRequired: 1, // 要求返回流媒体服务信息
        pageNum: 1,
        pageSize: 1000
      },
      // 标记定位过滤
      filterText: '',
      filteredGisMarkers: [],
      selectionType: '1', // 选择类型
      areaSelect: null, // 框选区域
      classificationMethod: '1', // 标注方式
      distanceMeasurementVisible: false, // 距离测量是否可见
      overviewVisible: true, // 缩略图是否可见
      scaleBarVisible: true, // 比例尺是否可见
      coordinateConversionVisible: false, // 取坐标是否可见
      // 视频节点信息弹窗
      streamNodeModalOpen: false,
      // 视频播放器弹窗
      videoPlayerModalOpen: false,
      videoPlayerModalVideoOpen: false // 打开视频标识
    }
  },
  components: {
    XdhMap,
    XdhMapImage,
    XdhMapZoom,
    XdhMapScale,
    XdhMapOverview,
    XdhMapPlacement,
    XdhMapPointer,
    XdhMapMeasure,
    AreaSelect,
    ShowStreamNodeModal,
    VideoPlayerModal
  },
  mixins: [
    ssoLoginMixin
  ],
  mounted () {

  },
  methods: {
    // 查询gis标记列表
    getGisMarkerList() {
      this.gisMarkerParams.regionId = 0
      this.gisMarkerParams.resourceId = 0
      this.gisMarkerParams.minZoom = this.mapZoom
      this.gisMarkerParams.geographyCoordinateFiltered = 1
      this.gisMarkerParams.minLongitude = this.geographicExtent[0]
      this.gisMarkerParams.minLatitude = this.geographicExtent[1]
      this.gisMarkerParams.maxLongitude = this.geographicExtent[2]
      this.gisMarkerParams.maxLatitude = this.geographicExtent[3]
      this.gisMarkerParams.filterText = ''
      this.gisMarkerParams.pageSize = 1000
      this.$http(this.$api.gisMarkerList, this.gisMarkerParams).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            let findIndex = this.gisMarkers.findIndex(item2 => { // 检测元素是否重复
              return item2.id === item.id && item2.resourceKind === item.resourceKind
            })
            if (findIndex < 0 && item.longitude && item.latitude) {
              item.position = [item.longitude, item.latitude]
              item.src = '/static/img/map/streamnode/' + item.icon
              // item.text = item.name // 不起作用
              // item.opacity = '0.2' // 不起作用
              // item.scale = '1.0'
              this.gisMarkers.push(item)
            }
          })
        }
      })
      console.log('>>> 查询gis标记列表')
    },
    // 根据过滤文本查询返回gis标记列表
    filterGisMarkerList(filterText, callback) {
      this.filteredGisMarkers = []
      this.gisMarkerParams.regionId = 0
      this.gisMarkerParams.resourceId = 0
      this.gisMarkerParams.minZoom = 0
      this.gisMarkerParams.geographyCoordinateFiltered = 0
      this.gisMarkerParams.filterText = filterText
      this.gisMarkerParams.pageSize = 20
      this.$http(this.$api.gisMarkerList, this.gisMarkerParams).then(res => {
        if (res.code === 200) {
          this.filteredGisMarkers = res.data
          if (this.filteredGisMarkers.length) {
            this.filteredGisMarkers.forEach(item => { // 添加value字段
              item.value = item.name
              item.position = [item.longitude, item.latitude]
              item.src = '/static/img/map/streamnode/' + item.icon
              // item.text = item.name // 不起作用
              // item.opacity = '0.2' // 不起作用
              // item.scale = '1.0'
            })
          }
        }
        if (callback) { // 回调
          callback(this.filteredGisMarkers)
        }
      })
    },
    // 添加并定位gis标记
    locateGisMarker(gisMarker) {
      let findIndex = this.gisMarkers.findIndex(item => { // 检测元素是否重复
        return item.id === gisMarker.id && item.resourceKind === gisMarker.resourceKind
      })
      if (findIndex < 0 && gisMarker.latitude && gisMarker.longitude) {
        this.gisMarkers.push(gisMarker)
      }
      this.currentGismarker = gisMarker
      this.$refs.xdhMap.moveTo(this.currentGismarker.position) // 地图居中
    },
    // 返回地图范围
    getMapGeographicExtent() {
      // 获取一个左上角和右下角坐标数组(4个数据)
      this.geographicExtent = this.rawMapView.calculateExtent(this.rawMap.getSize())
    },
    // 根据标注方式，返回当前标记图标
    getMarkerIcon(marker) {
      if (this.classificationMethod === '1') { // 不标注
        if (!marker.icon) {
          return ''
        }
        return '/static/img/map/streamnode/' + marker.icon
      } else if (this.classificationMethod === '2') { // 按地域标注
        if (!marker.iconByRegion) {
          return ''
        }
        return '/static/img/map/streamnode/' + marker.iconByRegion
      } else if (this.classificationMethod === '3') { // 按行业标注
        if (!marker.iconByRegionKind) {
          return ''
        }
        return '/static/img/map/streamnode/' + marker.iconByRegionKind
      }
      return ''
    },
    // 地图加载完成
    handleMapLoad: function (map, mapComp) {
      this.rawMap = this.$refs.xdhMap.map
      this.rawMapView = this.rawMap.getView()
      this.mapLoaded = true
      this.getMapGeographicExtent()

      // 监听地图移动事件
      this.$refs.xdhMap.map.on('moveend', e => {
        this.handleExtentChange()
      })

      // 创建框选框
      this.areaSelect = new AreaSelect(map, mapComp, {
        class: 'custom-drag-box',
        coordType: 'WGS84'
      })

      // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
      this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
        // 查询gis标记
        this.getGisMarkerList()
      })
    },
    // 地图将卸载
    handleMapUnload: function () {
      this.mapLoaded = false
      this.rawMap = null
      this.rawMapView = null
    },
    // 地图范围改变
    handleExtentChange: function () {
      if (!this.mapLoaded) {
        return
      }
      this.getMapGeographicExtent()

      // 启用防抖机制
      debounce(() => {
        this.getGisMarkerList()
      }, 1000)
    },
    // 根据过滤文本查询返回gis标记列表
    querySearch(queryString, callback) {
      // 启用防抖机制
      debounce(() => {
        if (queryString === '') { // 过滤文本为空不做查询
          return
        }
        this.filterGisMarkerList(queryString, callback)
      }, 2000)
    },
    // 点击查询结果选项时定位标记
    handleSelect(item) {
      this.locateGisMarker(item)
    },
    // 单击gis标记
    handleGisMarkerClick: function (e) {
      let _this = this
      this.rawMap.forEachFeatureAtPixel(e.pixel, function (feature, layer) { // 根据单击屏幕坐标返回标记
        let extent = feature.getGeometry().getExtent() // 返回范围（实际左上角和右下角坐标相同）
        let extentLeft = extent[0].toString()
        let extentTop = extent[1].toString()
        for (let i = 0; i < _this.gisMarkers.length; i++) {
          if (extentLeft === _this.gisMarkers[i].position[0].toString() &&
            extentTop === _this.gisMarkers[i].position[1].toString()) { // 转换成string后比较坐标
            _this.currentGismarker = _this.gisMarkers[i]
            _this.streamNodeModalOpen = true
            break
          }
        }
      })
    },
    // 框选
    handleBoxRadio(val) {
      if (val === '1') { // 单选
        this.rawMap.removeInteraction(this.areaSelect)
      }
      if (val === '2') { // 多选
        this.rawMap.addInteraction(this.areaSelect)
        this.videoPlayerModalVideoOpen = false
        this.selectedGismarkers = []
        this.areaSelect.on('boxend', e => {
          this.handleBoxSelectComplete(e)
        })
      }
    },
    // 地图框选完成
    handleBoxSelectComplete(e) {
      if (this.gisMarkers.length === 0) {
        return
      }
      this.selectedGismarkers = []
      this.gisMarkers.forEach(item => { // 返回选中标记集合
        if (e.areaGeo.intersectsCoordinate(item.position)) {
          this.selectedGismarkers.push(item)
        }
      })
      if (this.selectedGismarkers.length) { // 打开视频窗口
        if (!this.videoPlayerModalOpen) {
          this.videoPlayerModalOpen = true
        } else { // 重新打开视频
          this.videoPlayerModalVideoOpen = true
        }
      }
    },
    // 标注改变
    handleRadio(val) {
      this.gisMarkers.forEach(item => {
        let icon = this.getMarkerIcon(item)
        if (icon) {
          item.src = icon
        }
      })
    },
    // 工具箱命令
    handleCommand(command) {
      console.log('>>>>', command)
      // 测距
      if (command === 'distanceMeasure') {
        this.distanceMeasurementVisible = !this.distanceMeasurementVisible
        if (this.distanceMeasurementVisible) {
          this.$refs.measure.start()
        } else {
          this.$refs.measure.stop()
        }
      }
      // 鹰眼
      if (command === 'overviewMap') {
        this.overviewVisible = !this.overviewVisible
      }
      // 取点
      if (command === 'coordinateConversion') {
        this.coordinateConversionVisible = !this.coordinateConversionVisible
      }
      // 比例尺
      if (command === 'scaleBar') {
        this.scaleBarVisible = !this.scaleBarVisible
      }
    },
    // 坐标复制
    handleCoordinateCopy (coord) {
      // 启用节流阀机制(否则一次单击触发2次事件，原因不知）
      throttle(() => {
        this.$message.success('已复制取点坐标:' + coord)
      })
    },
    // 视频节点窗口关闭
    handleStreamNodeModalCancel() {
      this.streamNodeModalOpen = false
    },
    // 视频播放器窗口关闭
    handleVideoPlayerModalCancel() {
      this.videoPlayerModalOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/xdhDeviceMap/XdhDeviceMap.js